<template>
  <div class="tr-calc">
    <div>
      <h4>Item</h4>
      <dl>
        <template v-if="item.guide">
          <dt>Guia</dt>
          <dd>
            {{ item.guide.number || '—' }}<template v-if="guideType"> · {{ guideType }}</template>
          </dd>
        </template>
        <template v-if="item.origin === 'cashRegister'">
          <dt>Recibo</dt>
          <dd>{{ item.code || '—' }}</dd>
        </template>
        <template v-if="item.origin === 'medicalReport'">
          <dt>Laudo</dt>
          <dd>Assinado em {{ item.signedAt | date('datetime') }}</dd>
        </template>
        <template v-if="item.batch">
          <dt>Lote</dt>
          <dd>
            {{ item.batch.number || '—' }}
            <template v-if="insuranceName"> · {{ insuranceName }}</template>
          </dd>
        </template>
        <dt>Paciente</dt>
        <dd>{{ item.patient ? item.patient.name : '—' }}</dd>
        <template v-if="!item.batch">
          <dt>Convênio</dt>
          <dd>{{ insuranceName || '—' }}</dd>
        </template>
        <dt>Serviço</dt>
        <dd>
          <template v-if="item.expense && item.expense.code">{{ item.expense.code }} · </template>
          {{ item.expense ? item.expense.name : '—' }}
          <template v-if="item.quantity > 1"> · qtd {{ item.quantity }}</template>
        </dd>
        <dt>Data</dt>
        <dd>{{ item.date | date('datetime') }}</dd>
        <template v-if="item.executantXml">
          <dt>Executante (XML)</dt>
          <dd>{{ item.executantXml.name }}</dd>
        </template>
        <template v-if="item.role === 'requester'">
          <dt>Papel</dt>
          <dd>Solicitante</dd>
        </template>
        <dt>Regra aplicada</dt>
        <dd>
          {{ ruleText }}
          <template v-if="item.rule && item.rule.source"> — {{ item.rule.source }}</template>
        </dd>
        <template v-if="item.zeroReason">
          <dt>Sem repasse</dt>
          <dd>{{ zeroReasonLabel }}</dd>
        </template>
      </dl>
    </div>
    <div>
      <h4>Como foi calculado</h4>
      <div class="tr-calc-row" :class="row.classes" v-for="(row, i) in rows" :key="i">
        <span class="tr-calc-label">
          {{ row.label }}
          <i v-if="row.note">({{ row.note }})</i>
        </span>
        <span class="tr-calc-value" :class="{'text-muted': row.muted}">
          {{ row.value | currency }}
        </span>
      </div>
      <div class="tr-calc-note" v-if="showAdjustNote">
        Glosa e recuperação alteram o repasse enquanto o título estiver pendente;
        depois de pago viram ajuste na próxima consolidação.
      </div>
    </div>
  </div>
</template>

<script>
import { guideTypes, zeroReasons, ruleLabel } from '../helpers';

const KEEP_ZERO = ['Valor convênio', 'Valor paciente', 'Base bruta', 'Base do repasse', 'Repasse'];
const BASE_LABELS = ['Base bruta', 'Base do repasse'];

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    guideType() {
      return this.item.guide ? guideTypes[this.item.guide.type] || null : null;
    },
    insuranceName() {
      return this.item.insurance ? this.item.insurance.customName || this.item.insurance.name : '';
    },
    ruleText() {
      return ruleLabel(this.item.rule);
    },
    zeroReasonLabel() {
      return zeroReasons[this.item.zeroReason] || this.item.zeroReason;
    },
    showAdjustNote() {
      return this.item.status === 'pending' && (this.item.glossed > 0 || this.item.recovered > 0);
    },
    rows() {
      const trace = Array.isArray(this.item.trace) ? this.item.trace : [];
      const glossed = Number(this.item.glossed) || 0;
      const recovered = Number(this.item.recovered) || 0;
      const hasAdjust = glossed > 0 || recovered > 0;
      const rows = [];

      trace.forEach((step) => {
        const label = String(step.label || '');
        const value = Number(step.value) || 0;
        const isKept = KEEP_ZERO.includes(label) || /^(Retorno|Cortesia)/.test(label);
        if (value === 0 && !isKept) return;

        const classes = [];
        if (BASE_LABELS.includes(label)) classes.push('base');
        if (/^[−+×]/.test(label)) classes.push('sub');
        if (label === 'Repasse') classes.push(hasAdjust ? 'base' : 'total');
        if (/^Repasse do solicitante/.test(label)) classes.push('sub');

        rows.push({
          label,
          note: step.note || null,
          value,
          classes,
          muted: value === 0 && label === 'Valor paciente',
        });
      });

      if (hasAdjust) {
        if (glossed > 0) {
          rows.push({
            label: '− Glosa abatida', note: null, value: -glossed, classes: ['sub', 'gloss'],
          });
        }
        if (recovered > 0) {
          rows.push({
            label: '+ Recuperado por recurso',
            note: null,
            value: recovered,
            classes: ['sub', 'credit'],
          });
        }
        rows.push({
          label: 'Repasse líquido',
          note: null,
          value: Number(this.item.net) || 0,
          classes: ['total'],
        });
      }

      return rows;
    },
  },
};
</script>
